import { render, staticRenderFns } from "./NetworkIssue.vue?vue&type=template&id=5bfc5278&scoped=true&"
import script from "./NetworkIssue.vue?vue&type=script&lang=js&"
export * from "./NetworkIssue.vue?vue&type=script&lang=js&"
import style0 from "./NetworkIssue.vue?vue&type=style&index=0&id=5bfc5278&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfc5278",
  null
  
)

export default component.exports